import defaultEpaperImage from "@assets/epaper/EpaperImage.svg";
import Image from "@elements/ResponsiveImage/Image";
import { EPAPER_LINK } from "@helper/getEnvVariables";
import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

type PromotEpaperProps = {
  className?: string;
  epaperCoverImageUrl?: string;
};

export default function PromoteEpaper({
  className,
  epaperCoverImageUrl,
}: PromotEpaperProps) {
  return (
    <>
      <div
        id="promote-epaper"
        className={twMerge(
          "px-4 xmd:px-0 py-3 xmd:py-5 bg-red-300 inline-flex justify-start md:justify-center items-center gap-3 xmd:gap-6",
          className,
        )}
      >
        <Link
          reloadDocument
          to={EPAPER_LINK}
          target="_blank"
          rel="noreferrer"
          className="contents md:block"
        >
          <Image
            objectFit="contain"
            src={epaperCoverImageUrl ? epaperCoverImageUrl : defaultEpaperImage}
            className={twMerge(
              "mx-auto w-[100px] xmd:w-[152px] h-[135px] xmd:h-[202px]",
            )}
            srcWidth={150}
            srcHeight={202}
            alt="promote-epaper-desk"
            dataTestId="image"
          />
        </Link>
        <div className="text-left w-full md:w-58 xmd:w-97">
          <div className="w-60 xmd:w-97 font-bold font-primary text-2xl xmd:text-50 text-white leading-7 xmd:leading-10 capitalize justify-start">
            Read this week’s digital edition of Tabla! online
          </div>
          <Link
            reloadDocument
            to={EPAPER_LINK}
            target="_blank"
            rel="noreferrer"
            className="inline-flex w-full xmd:w-97 h-10 bg-yellow-100 items-center justify-center text-sm xmd:text-base font-bold leading-4 xmd:leading-5 font-opensans border-0 mt-2 xmd:mt-5"
          >
            Read our ePaper
          </Link>
        </div>
      </div>
    </>
  );
}
